<template>
  <div class="News">
    <PageBanner :bannerObj="bannerObj"></PageBanner>
    <div class="contain">
      <div class="c-header">
        <div class="c-title">{{ infoObj.title }}</div>
        <div class="clear">
          <div class="c-time fl">
            发布时间：
            <span>{{ infoObj.time }}</span>
          </div>
          <div class="c-time fr" v-if="type == 'impoptant'">
            来源：
            <span>广州工业投资控股集团有限公司官网-集团要闻栏目</span>
          </div>
        </div>
      </div>
      <div class="c-main ql-snow ql-editor" v-html="infoObj.content"></div>
      <div class="filecon" v-if="infoObj.fileUrl.length > 0">
        <div v-for="(item, index) in infoObj.fileUrl" :key="index" class="detail_file clear">
          <div class="fl detail_file_tit">附件</div>

          <a target="_blank" download :href="$store.state.fileUrlHeader + item.url">
            <div class="fl detail_file_f">
              {{ item.name }}
            </div>
          </a>
        </div>
      </div>
      <div class="c-footer clear">
        <div class="f-left">
          <router-link :to="
              '/newsDetails?id=' +
              infoObj.prev.id +
              '&index=' +
              infoObj.prev.index +
              '&type=' +
              $route.query.type
            " v-if="infoObj.prev">上一条：{{ infoObj.prev.title }}</router-link>
          <router-link :to="
              '/newsDetails?id=' +
              infoObj.next.id +
              '&index=' +
              infoObj.next.index +
              '&type=' +
              $route.query.type
            " v-if="infoObj.next">下一条：{{ infoObj.next.title }}</router-link>
          <!-- <router-link to="#">上一条：xxxx</router-link>
          <router-link to="#">下一条：xxxx</router-link>-->
        </div>
        <div class="f-right">
          <router-link to="/news" class="arows">返回 &nbsp; >></router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageBanner from "../../components/common/pageBanner"
export default {
  name: "News",
  metaInfo () {
    return {
      title: "新闻动态详情",
      meta: [
        { name: "keywords", content: "广州统计师事务所," + this.infoObj.title },
        { name: "description", content: this.infoObj.title },
      ],
    }
  },
  data () {
    return {
      bannerObj: {
        lableZh: "新闻动态",
        lableEn: "NEWS",
        bannerImg: require("../../assets/img/news/banner.jpg"),
      },
      infoObj: {},
      type: this.$route.query.type,
    }
  },
  created () {
    this.getinfo()
  },
  mounted () {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init()
    })
  },
  methods: {
    returnPre () {
      this.$router.go(-1)
    },
    onConversion (date) {
      if (date.indexOf("T") === -1) {
        return this.onConversion2(date)
      } else {
        return this.onConversion1(date)
      }
    },
    // 时间转换
    onConversion2 (date) {
      // console.log(1,date);
      var nDate = new Date(date.replace(new RegExp(/-/gm), "/"))
      // let nDate = new Date(date),
      var y = nDate.getFullYear(),
        m = ("0" + (nDate.getMonth() + 1)).slice(-2),
        d = ("0" + nDate.getDate()).slice(-2)
      // console.log(date)
      return y + "-" + m + "-" + d
    },
    onConversion1 (date) {
      // console.log(2,date);
      var arr = date.split("T")
      var d = arr[0]
      var darr = d.split("-")

      var dd =
        parseInt(darr[0]) +
        "-" +
        parseInt(darr[1]) +
        "-" +
        parseInt(darr[2]) +
        " "
      return dd
    },
    async getinfo () {
      let resQuery = this.$route.query
      let res, resDatalist, infoColumn
      if (resQuery.type === "company") {
        infoColumn = 0
      } else {
        infoColumn = 4
      }
      res = await this.$request.getNewInfoManageDetail({
        infoId: resQuery.id,
        infoColumn: infoColumn,
        column: 0,
      })
      let resNext = ""
      if (res.rows[0].next) {
        resNext = res.rows[0].next
      }

      let resPrev = ""
      if (res.rows[0].last) {
        resPrev = res.rows[0].last
      }

      resDatalist = {
        id: res.rows[0].infoManage.infoId,
        title: res.rows[0].infoManage.infoName,
        content: res.rows[0].infoManage.infoContent,
        fileUrl: res.rows[0].infoManage.fileUrl
          ? JSON.parse(res.rows[0].infoManage.fileUrl)
          : [],
        imgSrc: res.rows[0].infoManage.infoImage,
        index: resQuery.index,
        type: resQuery.type,
        time: this.onConversion(res.rows[0].infoManage.publishTime),
        next: resNext
          ? {
            id: resNext.infoId,
            title: resNext.infoName,
            index: resQuery.index - 0 + 1,
          }
          : "",
        prev: resPrev
          ? {
            id: resPrev.infoId,
            title: resPrev.infoName,
            index: resQuery.index - 0 - 1,
          }
          : "",
      }
      this.infoObj = resDatalist
      //   console.log(this.infoObj);
    },
  },
  watch: {
    // 监听路由发生改变
    $route: {
      handler (newVal) {
        if (newVal.query.id) this.getinfo()
      },
    },
  },
  components: { PageBanner },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.contain {
  width: 1200px;
  min-height: 600px;
  margin: 60px auto;
  padding: 0 0 130px 0;
  background-color: #f7f7f7;
  position: relative;
  .c-header {
    padding: 40px 0 40px 0;
    margin: 0 40px;
    text-align: left;
    border-bottom: 1px solid #cccccc;
    .c-title {
      display: inline-block;
      font-size: 24px;
      color: #333333;
      border-left: 10px solid $themeColor;
      padding: 0 0 0 10px;
      font-weight: bold;
    }

    .c-time {
      font-size: 16px;
      color: #666666;
      padding: 30px 0 0 0;
      font-weight: bold;
    }
  }
  .filecon {
    padding: 0 40px 45px;
    position: relative;
    .detail_file {
      display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      border: solid 1px #eee;
      background: #ffffff;
      margin-bottom: 10px;
      /* position: absolute;
            bottom: 30px;
            left: 30px; */
      .detail_file_tit {
        width: 104px;
        text-align: center;
        background: #cccccc;
      }

      .detail_file_f {
        color: $themeColor;
        font-size: 14px;
        text-decoration: underline;
        padding-left: 10px;
      }
    }
  }

  .c-footer {
    padding: 30px 0;
    margin: 0 40px;
    border-top: 1px solid #cccccc;
    width: 1120px;
    position: absolute;
    bottom: 0;
    left: 0;

    .f-left {
      float: left;
      width: 700px;

      a {
        font-size: 16px;
        color: #666666;
        padding: 10px 0;
        width: 700px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;

        &:hover {
          color: $themeColor;
        }
      }
    }

    .f-right {
      float: right;
      width: 130px;

      .arows {
        width: 130px;
        height: 30px;
        font-size: 16px;
        line-height: 30px;
        margin-top: 26px;
        background-color: $themeColor;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>

<style lang="scss">
.c-main {
  padding: 10px 40px 20px;

  img {
    max-width: 100% !important;
    display: inline-block;
    margin: 10px auto;
  }

  p {
    color: #333333;
    text-indent: 32px;
    font-size: 18px;
    line-height: 30px;
    padding: 6px 0;
  }

  span {
    color: #333333;
  }

  b {
    display: inline-block;
    font-size: 18px;
    line-height: 30px;
    padding: 10px 0;
  }
}
</style>
